/**
 *
 * @param localeLanguageCode
 * @returns {*}
 */
const extractLanguageCodeFromLocale = (localeLanguageCode) => {
  // Regular expression to match the pattern "ll_CC" where "ll" are two lowercase letters
  // and "CC" are two uppercase letters, separated by an underscore.

  const localePattern = /^([a-z]{2})_([A-Z]{2})$/;
  const match = localeLanguageCode.match(localePattern);

  if (match) {
    return match[1];
  } else {
    return localeLanguageCode;
  }
};

export default extractLanguageCodeFromLocale;
